import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  border-bottom: 1px solid #f1f2f6;
  margin: 0 10%;

  .left-side {
    display: flex;
    align-items: center;
    gap: 16px;

    .close-btn {
      width: 36px;
      height: 36px;
      border-radius: 14px;
      background: white;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      color: #1f1f52;
      font-size: 10px;
      i {
        font-size: 12px;
      }
    }

    .title {
      font-size: 20px;
      color: #1f1f52;

      strong {
        font-weight: 700;
      }
    }
  }

  .right-side {
    display: flex;
    align-items: center;
    gap: 20px;

    .patient-info {
      display: flex;
      align-items: center;
      gap: 12px;

      .texts {
        display: flex;
        flex-direction: column;

        .name {
          font-size: 17px;
          color: #1f1f52;
        }

        .condition {
          font-size: 15px;
          color: #3e3e5b;
        }
      }
    }

    .status-badge {
      display: flex;
      align-items: center;
      border-radius: 16.16px;
      padding: 5px 8px;
      gap: 8px;
      background-color: #ffffff;

      .status-badge__icon {
        font-size: 15px;
        color: #1f1f52;
      }

      .status-main {
        display: flex;
        flex-direction: column;
        color: #3e3e5b;
        font-size: 14px;
        font-family: "Nunito Sans Bold";

        i {
          font-size: 15px;
        }
        &__text {
          display: flex;
          gap: 8px;
          align-items: center;
        }
      }

      &__date {
        font-family: "Nunito Sans";
        font-size: 11.31px;
      }
      .status-sub {
        font-family: "Nunito Sans";
        font-size: 14px;
      }
    }
  }
`;
